export enum UserRoles {
  Administrator = 2,
  SystemAdministrator = 3,
  OnBehalfOf = 5,
  StaffAdministrator = 13,
}

export const STAFF_ROLE_IDS = [
  UserRoles.Administrator,
  UserRoles.SystemAdministrator,
  UserRoles.OnBehalfOf,
  UserRoles.StaffAdministrator,
];

export function isStaffUser(roleId: number | undefined): boolean {
  return STAFF_ROLE_IDS.includes(roleId ?? 0);
}
